import Link from "next/link";

/**
 * 导航链接
 * @param title 标题
 * @param type 类型 0-有下拉菜单 1-无下拉菜单
 * @param url 跳转链接
 * @param pathname 当前路由
 * @returns
 */
const NavLink = ({
  title,
  type = 0,
  url,
  pathname,
}: {
  title: string;
  type?: number;
  url: string;
  pathname: string;
}) => {
  return (
    <div className="group relative cursor-pointer font-semibold" data-qt="header_nav_click" data-qt-nav-url={url}>
      {type === 1 ? (
        <Link
          href={url}
          className={`  group-hover:text-primary
            ${pathname === url ? "text-primary" : "text-stone-500"}`}
        >
          {title}
        </Link>
      ) : (
        <div
          className={`  group-hover:text-primary
            ${pathname === url ? "text-primary" : "text-stone-500"}`}
        >
          {title}
        </div>
      )}

      <div
        className={`absolute bottom-r-4px left-50% ml-r-12px mt-1 hidden h-0.5 w-6 bg-primary
            ${pathname === url ? "t-block" : ""}`}
        style={{ transform: "skewX(-45deg)" }}
      ></div>
    </div>
  );
};

export default NavLink;
